import { useEffect, useMemo, useRef, useState } from 'react';
import _ from "lodash";

const useLastItemIsVisible = (items, itemsLoading) => {
  const itemsContainerRef = useRef(null);
  const [lastItemIsVisible, setLastItemIsVisible] = useState(false);

  const dependencies = [JSON.stringify(items)];

  const observer = useMemo(() => {
    return new IntersectionObserver(
    ([entry]) => {
      const itemsContainer = itemsContainerRef.current;
      if (_.size(itemsContainer?.children) != _.size(items)) return;
      setLastItemIsVisible(entry.isIntersecting);
    },
    {
      root: itemsContainerRef.current?.parentElement,
      threshold: 0.75,
    }
   )}, dependencies);

  useEffect(() => {
    setLastItemIsVisible(false);
    observer.disconnect();
  }, _.concat(dependencies, itemsLoading));

  useEffect(() => {
    const itemsContainer = itemsContainerRef.current;
    if (itemsContainer) {
      const lastChild = itemsContainer.lastElementChild;
      if (lastChild) observer.observe(lastChild);
    }

    return () => {
      if (itemsContainer) {
        const lastChild = itemsContainer.lastElementChild;
        if (lastChild) observer.unobserve(lastChild);
      }
    };
  }, dependencies);

  return { itemsContainerRef, lastItemIsVisible };
};

export default useLastItemIsVisible;